<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1" style="display: flex;">{{ $t('Pranešimai') }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Pranešimai. Pranešimai" mainTitle></el-tooltip></h1>
    <!-- search -->
    <notifications-search :loading="loading" @search="searchRecords" />
    <!-- add button  -->
    <el-button
      class="mb-3"
      small
      color="secondary"
      title="Žymėti visus kaip perskaitytus"
      :loading="loading"
      @click.native.stop="setAsRead(null, true)"
    />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header-sav"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :item-class="rowClass"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal'),
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="setItemParam(item)"
            @viewInModaltem="viewInModaltem(item)"
            @downloadItem="download(item)"
            @SetReadItem="setAsRead(item, false)"
          />
        </div>
      </template>
      <template #[`item.out_journal_type`]="{ item }">
        <el-table-enum
          enumName="outJournalTypeSav"
          :item="item.out_journal_type"
        />
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
     <modal-confirm
      :title="viewModalTitle"
      :text="viewModalText"
      v-model="showViewModal"
      info
      :loading="loading"
    />
  </v-container>
</template>

<script>
import NotificationsSearch from './NotificationsSearch'
import ModalConfirm from '@/components/modals/ModalConfirm'
import userRole from '@/mixins/userRole'
import math from '@/mixins/math'
import Enums from '@/enums'
import { mapGetters } from 'vuex'

export default {
  name: 'Notifications',
  components: {
    NotificationsSearch,
    ModalConfirm,
  },
  mixins: [userRole, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      listData: [],
      searchData: {},
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      showViewModal: false,
      viewModalTitle: "",
      viewModalText: "",
    }
  },
  computed: {
    ...mapGetters(['listParams','menuState']),
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          sortable: false,
          align: 'start',
          value: 'actions',
        },
        {
          text: this.$t('Pranešimo registracijos Nr.'),
          align: 'center',
          sortable: false,
          value: 'out_journal_no',
          width: '5rem',
        },
        {
          text: this.$t('Registro pranešimas'),
          align: 'center',
          value: 'out_journal_type',
        },
        {
          text: this.$t('Gavimo data'),
          align: 'start',
          value: 'sent_at',
          width: '9rem',
        },
        {
          text: this.$t('Objekto ID'),
          align: 'start',
          value: 'mandate_code',
          width: '9rem',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  created() {
    this.isMenuState()
    this.setlistParams()
  },
  methods: {
    isMenuState(){
      if(this.menuState == 'show_only_statements'){
        this.$router.push({
          name: 'savInfoPage',
          params: {
            type: 'showOnlyStatements',
          },
        })
      }
    },
    setlistParams(){
      if (this.listParams && (this.pagination.pageSize != this.listParams.pageSize) && (this.listParams.pageSize != null)) {
        this.pagination.pageSize = this.listParams.pageSize
      } 
    },
    viewInModaltem(item){
      this.showViewModal = true
      this.viewModalTitle = this.getObjByLang[item.sent_mode]
      this.viewModalText = item.text || ""
    },
    getObjByLang(){
      return this.$i18n.locale === 'lt' ? Enums.sentMode.lt : Enums.sentMode.en
    },
    setItemParam(item) {
      if(item.sent_mode == 'sms'){
        item.canViewSMS = true
      }
      if( item.sent_mode == 'email'){
        item.canViewEmail = true
      }
      if (!item.read) {
        item.canSetRead = true
      }
      return item
    },
    setAsRead(item, all) {
      const data = {
        id: item?.id || null,
        all: all,
      }
      this.$axios
        .post(`out-journals/read`, data)
        .then(() => {
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {})
    },
    getData(resetPageNr = false) {
      if(this.menuState == 'show_only_statements'){
        return
      }
      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`out-journals/my-list`, data)
        .then((res) => {
          this.listData = res.data.outJournals
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchRecords(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(true)
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    rowClass(item) {
      if (!item.read) {
        return `row-msg-unread`
      } else {
        return `row-msg-read`
      }
    },
    download(item) {
      this.loading = true
      this.$axios
        .get(`uploads/${item.upload_id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
